// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "_4_HOUR_MIN") {
      return /* FourHourMin */0;
    } else if (param === "_24_HOUR_BUSINESS_CANCELLATION") {
      return /* TwentyFourHourBusinessCancellation */2;
    } else {
      return /* EstimatedShiftPayMinimum */1;
    }
  }
  
}

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "24 hour business cancellation" :
                      return /* TwentyFourHourBusinessCancellation */2;
                  case "4 hour min" :
                      return /* FourHourMin */0;
                  case "estimated shift pay minimum" :
                      return /* EstimatedShiftPayMinimum */1;
                  default:
                    return ;
                }
              }), param);
}

function toString(param) {
  switch (param) {
    case /* FourHourMin */0 :
        return "4 Hour Min";
    case /* EstimatedShiftPayMinimum */1 :
        return "Estimated Shift Pay Minimum";
    case /* TwentyFourHourBusinessCancellation */2 :
        return "24 Hour Business Cancellation";
    
  }
}

function toDisplayString(param) {
  switch (param) {
    case /* FourHourMin */0 :
        return "4hr Min";
    case /* EstimatedShiftPayMinimum */1 :
        return "Est. Shift Pay Min";
    case /* TwentyFourHourBusinessCancellation */2 :
        return "24hr Biz Cancellation";
    
  }
}

function toApiString(param) {
  switch (param) {
    case /* FourHourMin */0 :
        return "_4_HOUR_MIN";
    case /* EstimatedShiftPayMinimum */1 :
        return "ESTIMATED_SHIFT_PAY_MINIMUM";
    case /* TwentyFourHourBusinessCancellation */2 :
        return "_24_HOUR_BUSINESS_CANCELLATION";
    
  }
}

function toLineItemString(param) {
  switch (param) {
    case /* FourHourMin */0 :
        return "4 Hour Min";
    case /* EstimatedShiftPayMinimum */1 :
        return "Min Shift";
    case /* TwentyFourHourBusinessCancellation */2 :
        return "24 Hour Cancellation - 4 Hour Min Policy";
    
  }
}

function fromEnum(param) {
  return param;
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* FourHourMin */0;
    case 1 :
        return /* EstimatedShiftPayMinimum */1;
    case 2 :
        return /* TwentyFourHourBusinessCancellation */2;
    default:
      return ;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var decode = Curry._1(Json.Decode.variantFromString, fromString);

var FlagType_fromEnum = include.fromEnum;

var FlagType_toEnum = include.toEnum;

var FlagType_eq = include.eq;

var FlagType_compare = include.compare;

var FlagType_Ord = include.Ord;

var FlagType_compareWithConversion = include.compareWithConversion;

var FlagType_compareReversed = include.compareReversed;

var FlagType_OrdReversed = include.OrdReversed;

var FlagType_compareAsInt = include.compareAsInt;

var FlagType_min = include.min;

var FlagType_max = include.max;

var FlagType_lessThan = include.lessThan;

var FlagType_lt = include.lt;

var FlagType_lessThanOrEq = include.lessThanOrEq;

var FlagType_lte = include.lte;

var FlagType_greaterThan = include.greaterThan;

var FlagType_gt = include.gt;

var FlagType_greaterThanOrEq = include.greaterThanOrEq;

var FlagType_gte = include.gte;

var FlagType_clamp = include.clamp;

var FlagType_between = include.between;

var FlagType_OrdRingExtensions = include.OrdRingExtensions;

var FlagType_OrdNamed = include.OrdNamed;

var FlagType_OrdBy = include.OrdBy;

var FlagType_Set = include.$$Set;

var FlagType_SetWithNone = include.SetWithNone;

var FlagType_Map = include.$$Map;

var FlagType_list = include.list;

var FlagType_array = include.array;

var FlagType_set = include.set;

var FlagType_setWithNone = include.setWithNone;

var FlagType_cardinality = include.cardinality;

var FlagType_top = include.top;

var FlagType_bottom = include.bottom;

var FlagType_succ = include.succ;

var FlagType_pred = include.pred;

var FlagType = {
  parseApiResponse: parseApiResponse,
  fromString: fromString,
  toString: toString,
  toDisplayString: toDisplayString,
  toApiString: toApiString,
  toLineItemString: toLineItemString,
  fromEnum: FlagType_fromEnum,
  toEnum: FlagType_toEnum,
  eq: FlagType_eq,
  compare: FlagType_compare,
  Ord: FlagType_Ord,
  compareWithConversion: FlagType_compareWithConversion,
  compareReversed: FlagType_compareReversed,
  OrdReversed: FlagType_OrdReversed,
  compareAsInt: FlagType_compareAsInt,
  min: FlagType_min,
  max: FlagType_max,
  lessThan: FlagType_lessThan,
  lt: FlagType_lt,
  lessThanOrEq: FlagType_lessThanOrEq,
  lte: FlagType_lte,
  greaterThan: FlagType_greaterThan,
  gt: FlagType_gt,
  greaterThanOrEq: FlagType_greaterThanOrEq,
  gte: FlagType_gte,
  clamp: FlagType_clamp,
  between: FlagType_between,
  OrdRingExtensions: FlagType_OrdRingExtensions,
  OrdNamed: FlagType_OrdNamed,
  OrdBy: FlagType_OrdBy,
  $$Set: FlagType_Set,
  SetWithNone: FlagType_SetWithNone,
  $$Map: FlagType_Map,
  list: FlagType_list,
  array: FlagType_array,
  set: FlagType_set,
  setWithNone: FlagType_setWithNone,
  cardinality: FlagType_cardinality,
  top: FlagType_top,
  bottom: FlagType_bottom,
  succ: FlagType_succ,
  pred: FlagType_pred,
  decode: decode
};

function flag(param_0) {
  return /* Flag */{
          _0: param_0
        };
}

function make(maybeFlag, isOverfill) {
  if (isOverfill) {
    return Relude_Option.pure(/* Overfill */0);
  } else {
    return Relude_Option.map(flag, maybeFlag);
  }
}

function decode$1(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make, Curry._3(Json.Decode.field, "flag", Curry._1(Json.Decode.optional, decode), json)), Curry._3(Json.Decode.field, "is_overfill", Json.Decode.$$boolean, json));
}

var overfill = /* Overfill */0;

exports.FlagType = FlagType;
exports.overfill = overfill;
exports.flag = flag;
exports.make = make;
exports.decode = decode$1;
/* include Not a pure module */
